import type { Game } from '@olagg/db-types'
import { AdminGameEndpoints } from '../endpoints/adminEndpoints'
import { useQ } from './useQ'

export const useAdminGame = ({ slug }: { slug: string }) =>
  useQ<{ game: Game }>(
    AdminGameEndpoints.find(slug), { revalidateOnFocus: false }
  )
